import { SwitchProductModule } from '@wix/package-picker-sdk';
import { getSearchParams } from '@wix/package-picker-shared';
export const useSwitchFlows = () => {
  var _isSwitchFlowQuery$da;
  const {
    isDowngradeEnabled
  } = getSearchParams();
  const isSwitchFlowQuery = SwitchProductModule.SDK.switchApiClient.hooks.useIsSwitchFlow({});
  const currentProductQuery = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const isSwitchFlow = (_isSwitchFlowQuery$da = isSwitchFlowQuery.data) == null ? void 0 : _isSwitchFlowQuery$da.isSwitchFlow;
  const allQueries = [isSwitchFlowQuery, currentProductQuery];
  const isLoading = allQueries.some(q => q.isLoading);
  const isSuccess = allQueries.every(q => q.isSuccess);
  const isError = allQueries.some(q => q.isError);
  const isDowngradeFlow = Boolean(isDowngradeEnabled && isSwitchFlow);
  const isUpgradeFlow = Boolean(!isDowngradeEnabled && isSwitchFlow);
  return {
    isSuccess,
    isLoading,
    isError,
    isUpgradeFlow,
    isDowngradeFlow,
    isSwitchFlow
  };
};
//# sourceMappingURL=useSwitchFlows.js.map